var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content mb-5" },
              [
                _vm.showMobile
                  ? _c(
                      "div",
                      { key: "mobile", staticClass: "row position-relative" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 order-1 quick-infos-wrapper d-flex align-items-center mb-4 px-0 px-md-3"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "quick-infos w-100 d-flex flex-wrap align-items-end justify-content-between p-3 p-md-4 mt-4 positon-relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "player-image position-relative mr-0 mr-md-3 mb-3 text-center"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid border-radius",
                                      attrs: {
                                        src:
                                          _vm.currentVariation.images.all[0]
                                            .urlPreview,
                                        alt: _vm._f("itemName")(
                                          _vm.currentVariation
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.isClosed()
                                      ? _c("div", { staticClass: "closed" }, [
                                          _vm._m(0)
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.tagName && !_vm.isClosed()
                                      ? _c("div", { staticClass: "tag" }, [
                                          _c(
                                            "span",
                                            { staticClass: "badge bg-danger" },
                                            [_vm._v(_vm._s(_vm.tagName))]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.hasProperty82()
                                      ? _c(
                                          "p",
                                          { staticClass: "ki-info mb-0" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "badge" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-info-circle mr-1",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "FanLiebling::Singleitem.KIImage"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", { staticClass: "mb-3" }, [
                                    _c(
                                      "h1",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("itemName")(
                                              _vm.currentVariation
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "player-wrapper mb-3" },
                                    [
                                      _vm.position()
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "d-block headline mb-0"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-map-marker mr-1",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v("Position")
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "content mb-0" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.position()) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "from-to-wrapper mb-3" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "headline d-block" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-exchange mr-1",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "FanLiebling::Singleitem.fromToHeadline"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "content mb-0" },
                                        [
                                          _vm._t("from-club-title"),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-long-arrow-right arrow mx-2",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(" "),
                                          _vm._t("to-club-title")
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm.probability() !== false ||
                                  _vm.progression() !== false
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "probability-wrapper mb-3"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "headline d-block" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-handshake-o mr-1",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "FanLiebling::Singleitem.probabilityHeadline"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "content mb-0" },
                                            [
                                              _vm.probability() !== false
                                                ? [
                                                    _vm.probability() === "?"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.probability()
                                                            )
                                                          )
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.probability()
                                                            ) + "%"
                                                          )
                                                        ])
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.progression() !== false
                                                ? [
                                                    _c("i", {
                                                      class: {
                                                        "fa text-danger fa-arrow-down":
                                                          _vm.progression() ===
                                                          "Fallend",
                                                        "fa text-success fa-arrow-up":
                                                          _vm.progression() ===
                                                          "Steigend"
                                                      },
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.marketValue()
                                    ? _c(
                                        "div",
                                        { staticClass: "market-wrapper mb-3" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "d-block headline mb-0"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-line-chart mr-1",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "FanLiebling::Singleitem.marketValue"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "content mb-0" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formattedMarketValue
                                                ) + " €"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    !_vm.isClosed()
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-outline-primary support-btn font-weight-bold border-radius",
                                            attrs: { href: "#support" }
                                          },
                                          [
                                            _vm.isSameClub()
                                              ? [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "FanLiebling::Singleitem.ButtonSupportStay"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "FanLiebling::Singleitem.ButtonSupport"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 order-4 editorial justify-content-between my-5"
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-between"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "h2 title mb-3",
                                      attrs: { "data-testing": "item-name" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.texts.name2
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(1)
                                ]
                              ),
                              _vm._v(" "),
                              _vm.editorialDate()
                                ? _c("div", {
                                    staticClass: "editorialDate mb-3",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.editorialDate())
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.editorialText()
                                ? _c("div", {
                                    staticClass: "editorialText mb-0",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.removeIsPastedId(
                                          _vm.editorialText()
                                        )
                                      )
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.crossSelling
                          ? _c(
                              "div",
                              {
                                staticClass: "col-12 xselling mb-4 order-7",
                                attrs: { id: "competition" }
                              },
                              [
                                _c("div", { staticClass: "col-12 px-0" }, [
                                  _c(
                                    "p",
                                    { staticClass: "h3 font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "FanLiebling::Singleitem.SimilarHeadline"
                                          )
                                        ) +
                                          _vm._s(
                                            _vm._f("itemName")(
                                              _vm.currentVariation
                                            )
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr")
                                ]),
                                _vm._v(" "),
                                _vm._t("cross-selling-similar")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 order-4 support-box border-radius p-3 p-md-4 position-relative mb-4",
                            attrs: { id: "support" }
                          },
                          [
                            _vm.isWishListEnabled
                              ? _c(
                                  "div",
                                  { staticClass: "fl-wishlist" },
                                  [
                                    _c("add-to-wish-list", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isClosed()
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "support-wrapper d-flex justify-content-between mb-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _vm.isSameClub()
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-bold h3 d-block mb-3"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "FanLiebling::Singleitem.supportStayHeadline"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-bold h3 d-block mb-3"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "FanLiebling::Singleitem.supportHeadline"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "subheadline" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "FanLiebling::Singleitem.supportSubHeadline"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("before-price"),
                            _vm._v(" "),
                            _vm._t("after-price"),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-3" }, [
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("before-add-to-basket")],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-3" }, [
                                _vm.isClosed()
                                  ? _c("div", { staticClass: "mb-5" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "font-weight-bold mb-0"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "FanLiebling::Singleitem.closedHeadline"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$translate(
                                                "FanLiebling::Singleitem.closedText"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.isClosedMessage()
                                        ? _c("div", [
                                            _c("p", {
                                              staticClass: "text-success h2",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.isClosedMessage()
                                                )
                                              }
                                            })
                                          ])
                                        : _vm._e()
                                    ])
                                  : _c(
                                      "div",
                                      { staticClass: "add-to-basket" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex properties-wrapper"
                                          },
                                          [
                                            _c("order-property-list"),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "club-title" },
                                              [
                                                _vm._v("("),
                                                _vm._t("to-club-title"),
                                                _vm._v(")")
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("add-to-basket", {
                                          attrs: {
                                            "variation-id":
                                              _vm.currentVariation.variation.id,
                                            "is-salable":
                                              !!_vm.currentVariation.filter &&
                                              _vm.currentVariation.filter
                                                .isSalable,
                                            "has-children":
                                              !!_vm.currentVariation.filter &&
                                              _vm.currentVariation.filter
                                                .hasActiveChildren,
                                            "interval-quantity":
                                              _vm.currentVariation.variation
                                                .intervalOrderQuantity || 1,
                                            "minimum-quantity":
                                              _vm.currentVariation.variation
                                                .minimumOrderQuantity,
                                            "maximum-quantity":
                                              !!_vm.currentVariation.variation
                                                .maximumOrderQuantity &&
                                              _vm.currentVariation.variation
                                                .maximumOrderQuantity > 0
                                                ? _vm.currentVariation.variation
                                                    .maximumOrderQuantity
                                                : null,
                                            "order-properties": _vm.currentVariation.properties.filter(
                                              function(prop) {
                                                return prop.property
                                                  .isOderProperty
                                              }
                                            ),
                                            "has-order-properties":
                                              _vm.currentVariation
                                                .hasOrderProperties,
                                            "has-required-order-property":
                                              _vm.currentVariation
                                                .hasRequiredOrderProperty,
                                            "use-large-scale": false,
                                            "show-quantity": true,
                                            "item-url": _vm._f("itemURL")(
                                              _vm.currentVariation
                                            ),
                                            "is-variation-selected":
                                              _vm.isVariationSelected &&
                                              _vm.currentVariation.filter
                                                .isSalable,
                                            "has-price": _vm._f(
                                              "hasItemDefaultPrice"
                                            )(_vm.currentVariation)
                                          }
                                        })
                                      ],
                                      1
                                    )
                              ]),
                              _vm._v(" "),
                              _vm.currentVariation.filter.isSalable &&
                              _vm.variationGroupedProperties.length &&
                              !_vm.isClosed()
                                ? _c("div")
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sales() && !_vm.isClosed()
                                ? _c("p", { staticClass: "sales mb-3" }, [
                                    _vm.sales() >= 5 && _vm.sales() < 10
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                Dein Fanliebling hat fast 10 Unterstützer erreicht!\n              "
                                          )
                                        ])
                                      : _vm.sales() >= 10 && _vm.sales() < 20
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                Dein Fanliebling hat mehr als 10 Unterstützer erreicht!\n              "
                                          )
                                        ])
                                      : _vm.sales() >= 20 && _vm.sales() <= 30
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                Dein Fanliebling begeistert bereits über 20 Unterstützer!\n              "
                                          )
                                        ])
                                      : _vm.sales() > 30
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                Dein Fanliebling hat schon über " +
                                              _vm._s(_vm.sales()) +
                                              " Unterstützer begeistert!\n              "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-100 pp-button" },
                                [_vm._t("after-add-to-basket")],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _vm._t("additional-content-after-add-to-basket"),
                            _vm._v(" "),
                            _vm._t("additional-content-after-vat")
                          ],
                          2
                        ),
                        _vm._v(" "),
                        !_vm.isClosed()
                          ? _c("div", { staticClass: "col-12 order-5 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "how-it-works p-3 border-radius"
                                },
                                [
                                  _c("p", { staticClass: "headline mb-1" }, [
                                    _vm._v("Wie funktioniert es?")
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", { staticClass: "pl-3 mb-0" }, [
                                    _c("li", [
                                      _vm._v(
                                        "\n                Du unterstützt den Wechsel (od. Verbleib) deines Fanliebling mit deinem gewählten Beitrag\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "FanLiebling::Singleitem.HowToIcon1Text"
                                            )
                                          )
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v("\n                a) "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "FanLiebling::Singleitem.HowToIcon3Text"
                                            )
                                          )
                                        }
                                      }),
                                      _c("br"),
                                      _vm._v("\n                b) "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "FanLiebling::Singleitem.HowToIcon4Text"
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-6 order-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "player-infos border-radius p-md-4 mb-4"
                            },
                            [
                              _c("p", { staticClass: "font-weight-bold h3" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "FanLiebling::Singleitem.playerHeadline"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "mt-3 w-100",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.description
                                  )
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.currentVariation.texts.technicalData &&
                        _vm.currentVariation.texts.technicalData.trim() !== ""
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-sm-6 order-6" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "player-infos border-radius p-md-4 mb-4"
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "font-weight-bold h3" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "FanLiebling::Singleitem.playerTechnicalHeadline"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "player-infos mt-3",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVariation.texts
                                            .technicalData
                                        )
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "col-12 col-sm-6 order-6" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "player-infos border-radius p-md-4 mb-4"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex mb-3 align-items-center fromClub"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "font-weight-bold h3"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "FanLiebling::Singleitem.fromClub"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                            _c(
                                              "span",
                                              [_vm._t("from-club-title")],
                                              2
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "fromClub" },
                                      [_vm._t("from-club-description")],
                                      2
                                    )
                                  ]
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 order-8 mb-4" },
                          [
                            _c("feedback-container", {
                              staticClass: "fl-discuss",
                              attrs: {
                                options: {
                                  allowFeedbacksOnlyIfPurchased: false,
                                  allowNoRatingFeedback: true,
                                  feedbacksPerPage: 10,
                                  numberOfFeedbacks: 1,
                                  timestampVisibility: true,
                                  allowGuestFeedbacks: true
                                },
                                classes: "",
                                styles: ""
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-sm-6 order-9 mb-4" },
                          [_vm._t("cross-selling-tag-new")],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-sm-6 order-10 mb-4" },
                          [_vm._t("cross-selling-tag-top")],
                          2
                        )
                      ]
                    )
                  : _c(
                      "div",
                      { key: "desktop", staticClass: "row position-relative" },
                      [
                        _c(
                          "div",
                          { staticClass: "left-col col-lg-8 mt-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "quick-infos-wrapper d-flex align-items-center mb-4"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "quick-infos w-100 d-flex flex-wrap align-items-end justify-content-between p-2 p-md-4 positon-relative"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "player-image position-relative mr-0 mr-md-3"
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "img-fluid border-radius",
                                          attrs: {
                                            src:
                                              _vm.currentVariation.images.all[0]
                                                .urlPreview,
                                            alt: _vm._f("itemName")(
                                              _vm.currentVariation
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.isClosed()
                                          ? _c(
                                              "div",
                                              { staticClass: "closed" },
                                              [_vm._m(2)]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.tagName && !_vm.isClosed()
                                          ? _c("div", { staticClass: "tag" }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "badge bg-danger"
                                                },
                                                [_vm._v(_vm._s(_vm.tagName))]
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.hasProperty82()
                                          ? _c(
                                              "p",
                                              { staticClass: "ki-info mb-0" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "badge" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-info-circle mr-1",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "FanLiebling::Singleitem.KIImage"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c(
                                          "h1",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("itemName")(
                                                  _vm.currentVariation
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "player-wrapper mb-0 mb-md-3"
                                        },
                                        [
                                          _vm.position()
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "d-block headline mb-0"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-map-marker mr-1",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  }),
                                                  _vm._v("Position")
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "content mb-0" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.position()) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "from-to-wrapper mb-3 mb-md-0"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "headline d-block" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-exchange mr-1",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "FanLiebling::Singleitem.fromToHeadline"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content mb-0" },
                                            [
                                              _vm._t("from-club-title"),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-long-arrow-right arrow mx-2",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(" "),
                                              _vm._t("to-club-title")
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm.probability() !== false ||
                                      _vm.progression() !== false
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "probability-wrapper mb-0 mb-md-3"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "headline d-block"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-handshake-o mr-1",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "FanLiebling::Singleitem.probabilityHeadline"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "content mb-0" },
                                                [
                                                  _vm.probability() !== false
                                                    ? [
                                                        _vm.probability() ===
                                                        "?"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.probability()
                                                                )
                                                              )
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.probability()
                                                                ) + "%"
                                                              )
                                                            ])
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.progression() !== false
                                                    ? [
                                                        _c("i", {
                                                          class: {
                                                            "fa text-danger fa-arrow-down":
                                                              _vm.progression() ===
                                                              "Fallend",
                                                            "fa text-success fa-arrow-up":
                                                              _vm.progression() ===
                                                              "Steigend"
                                                          },
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        })
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.marketValue()
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "market-wrapper mb-3 mb-md-0"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "d-block headline mb-0"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-line-chart mr-1",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "FanLiebling::Singleitem.marketValue"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "content mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formattedMarketValue
                                                    ) + " €"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      !_vm.isClosed()
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-outline-primary support-btn font-weight-bold border-radius",
                                              attrs: { href: "#support" }
                                            },
                                            [
                                              _vm.isSameClub()
                                                ? [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "FanLiebling::Singleitem.ButtonSupportStay"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "FanLiebling::Singleitem.ButtonSupport"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "editorial justify-content-between my-5"
                              },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between"
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "h2 title mb-3",
                                          attrs: { "data-testing": "item-name" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.texts
                                                    .name2
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(3)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.editorialDate()
                                    ? _c("div", {
                                        staticClass: "editorialDate mb-3",
                                        domProps: {
                                          innerHTML: _vm._s(_vm.editorialDate())
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editorialText()
                                    ? _c("div", {
                                        staticClass: "editorialText mb-0",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.removeIsPastedId(
                                              _vm.editorialText()
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "support-box border-radius p-3 p-md-4 position-relative mb-4",
                                attrs: { id: "support" }
                              },
                              [
                                _vm.isWishListEnabled
                                  ? _c(
                                      "div",
                                      { staticClass: "fl-wishlist" },
                                      [
                                        _c("add-to-wish-list", {
                                          attrs: {
                                            "variation-id":
                                              _vm.currentVariation.variation.id
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isClosed()
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "support-wrapper d-flex justify-content-between mb-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm.isSameClub()
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold h3 d-block mb-3"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "FanLiebling::Singleitem.supportStayHeadline"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold h3 d-block mb-3"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "FanLiebling::Singleitem.supportHeadline"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "subheadline" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "FanLiebling::Singleitem.supportSubHeadline"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._t("before-price"),
                                _vm._v(" "),
                                _vm._t("after-price"),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "w-100" },
                                    [_vm._t("before-add-to-basket")],
                                    2
                                  ),
                                  _vm._v(" "),
                                  !_vm.isClosed()
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex properties-wrapper"
                                        },
                                        [
                                          _c("order-property-list"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "club-title" },
                                            [
                                              _vm._v("("),
                                              _vm._t("to-club-title"),
                                              _vm._v(")")
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt-3" }, [
                                    _vm.isClosed()
                                      ? _c("div", { staticClass: "mb-5" }, [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "font-weight-bold mb-0"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "FanLiebling::Singleitem.closedHeadline"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "FanLiebling::Singleitem.closedText"
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.isClosedMessage()
                                            ? _c("div", [
                                                _c("p", {
                                                  staticClass:
                                                    "text-success h2",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.isClosedMessage()
                                                    )
                                                  }
                                                })
                                              ])
                                            : _vm._e()
                                        ])
                                      : _c(
                                          "div",
                                          { staticClass: "add-to-basket" },
                                          [
                                            _c("add-to-basket", {
                                              attrs: {
                                                "variation-id":
                                                  _vm.currentVariation.variation
                                                    .id,
                                                "is-salable":
                                                  !!_vm.currentVariation
                                                    .filter &&
                                                  _vm.currentVariation.filter
                                                    .isSalable,
                                                "has-children":
                                                  !!_vm.currentVariation
                                                    .filter &&
                                                  _vm.currentVariation.filter
                                                    .hasActiveChildren,
                                                "interval-quantity":
                                                  _vm.currentVariation.variation
                                                    .intervalOrderQuantity || 1,
                                                "minimum-quantity":
                                                  _vm.currentVariation.variation
                                                    .minimumOrderQuantity,
                                                "maximum-quantity":
                                                  !!_vm.currentVariation
                                                    .variation
                                                    .maximumOrderQuantity &&
                                                  _vm.currentVariation.variation
                                                    .maximumOrderQuantity > 0
                                                    ? _vm.currentVariation
                                                        .variation
                                                        .maximumOrderQuantity
                                                    : null,
                                                "order-properties": _vm.currentVariation.properties.filter(
                                                  function(prop) {
                                                    return prop.property
                                                      .isOderProperty
                                                  }
                                                ),
                                                "has-order-properties":
                                                  _vm.currentVariation
                                                    .hasOrderProperties,
                                                "has-required-order-property":
                                                  _vm.currentVariation
                                                    .hasRequiredOrderProperty,
                                                "use-large-scale": false,
                                                "show-quantity": true,
                                                "item-url": _vm._f("itemURL")(
                                                  _vm.currentVariation
                                                ),
                                                "is-variation-selected":
                                                  _vm.isVariationSelected &&
                                                  _vm.currentVariation.filter
                                                    .isSalable,
                                                "has-price": _vm._f(
                                                  "hasItemDefaultPrice"
                                                )(_vm.currentVariation)
                                              }
                                            })
                                          ],
                                          1
                                        )
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentVariation.filter.isSalable &&
                                  _vm.variationGroupedProperties.length &&
                                  !_vm.isClosed()
                                    ? _c("div")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.sales() && !_vm.isClosed()
                                    ? _c("p", { staticClass: "sales mb-3" }, [
                                        _vm.sales() >= 5 && _vm.sales() < 10
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  Dein Fanliebling hat fast 10 Unterstützer erreicht!\n                "
                                              )
                                            ])
                                          : _vm.sales() >= 10 &&
                                            _vm.sales() < 20
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  Dein Fanliebling hat mehr als 10 Unterstützer erreicht!\n                "
                                              )
                                            ])
                                          : _vm.sales() >= 20 &&
                                            _vm.sales() <= 30
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  Dein Fanliebling begeistert bereits über 20 Unterstützer!\n                "
                                              )
                                            ])
                                          : _vm.sales() > 30
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  Dein Fanliebling hat schon über " +
                                                  _vm._s(_vm.sales()) +
                                                  " Unterstützer begeistert!\n                "
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "w-100 pp-button" },
                                    [_vm._t("after-add-to-basket")],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._t(
                                  "additional-content-after-add-to-basket"
                                ),
                                _vm._v(" "),
                                _vm._t("additional-content-after-vat")
                              ],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.isClosed()
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "how-it-works border-radius p-2 p-md-4 mb-4"
                                  },
                                  [
                                    _c("p", { staticClass: "headline mb-1" }, [
                                      _vm._v("Wie funktioniert es?")
                                    ]),
                                    _vm._v(" "),
                                    _c("ol", { staticClass: "pl-3 mb-0" }, [
                                      _c("li", [
                                        _vm._v(
                                          "\n                Du unterstützt den Wechsel deines Fanliebling mit deinem gewählten Beitrag\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$translate(
                                                "FanLiebling::Singleitem.HowToIcon1Text"
                                              )
                                            )
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v("\n                a) "),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$translate(
                                                "FanLiebling::Singleitem.HowToIcon3Text"
                                              )
                                            )
                                          }
                                        }),
                                        _c("br"),
                                        _vm._v("\n                b) "),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$translate(
                                                "FanLiebling::Singleitem.HowToIcon4Text"
                                              )
                                            )
                                          }
                                        })
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("feedback-container", {
                              staticClass: "fl-discuss",
                              attrs: {
                                options: {
                                  allowFeedbacksOnlyIfPurchased: false,
                                  allowNoRatingFeedback: true,
                                  feedbacksPerPage: 10,
                                  numberOfFeedbacks: 1,
                                  timestampVisibility: true,
                                  allowGuestFeedbacks: true
                                },
                                classes: "",
                                styles: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "fromClub my-5" }, [
                              _c("p", { staticClass: "font-weight-bold h3" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "FanLiebling::Singleitem.fromClub"
                                      )
                                    )
                                ),
                                _c("span", [_vm._t("from-club-title")], 2)
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 px-0" },
                                [_vm._t("from-club-description")],
                                2
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "right-col col-lg-4 mt-4" },
                          [
                            _c("div", { staticClass: "player-infos mb-4" }, [
                              _c("p", { staticClass: "font-weight-bold h3" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "FanLiebling::Singleitem.playerHeadline"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "mt-3 w-100",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.description
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.currentVariation.texts.technicalData &&
                            _vm.currentVariation.texts.technicalData.trim() !==
                              ""
                              ? _c(
                                  "div",
                                  { staticClass: "player-infos mb-4" },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "font-weight-bold h3" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "FanLiebling::Singleitem.playerTechnicalHeadline"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "player-infos mt-3",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVariation.texts
                                            .technicalData
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.crossSelling
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "xselling mb-4 pt-4",
                                    attrs: { id: "competition" }
                                  },
                                  [
                                    _c("div", { staticClass: "col-12 px-0" }, [
                                      _c(
                                        "p",
                                        { staticClass: "h3 font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "FanLiebling::Singleitem.SimilarHeadline"
                                              )
                                            ) +
                                              _vm._s(
                                                _vm._f("itemName")(
                                                  _vm.currentVariation
                                                )
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr")
                                    ]),
                                    _vm._v(" "),
                                    _vm._t("cross-selling-similar")
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("cross-selling-tag-new"),
                            _vm._v(" "),
                            _vm._t("cross-selling-tag-top")
                          ],
                          2
                        )
                      ]
                    )
              ]
            )
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message" }, [
      _c("span", [
        _c("i", {
          staticClass: "fa fa-lock mr-1",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("Gerücht"),
        _c("br"),
        _vm._v("geschlossen")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "share menu", attrs: { id: "shareDiv" } }, [
      _c("li", { staticClass: "share top" }, [
        _c("i", { staticClass: "fa fa-share-alt" }),
        _vm._v(" "),
        _c("ul", { staticClass: "submenu" }, [
          _c("li", [
            _c(
              "a",
              {
                staticClass: "facebook",
                attrs: {
                  id: "share-facebook",
                  href: "javascript:void(0);",
                  onclick: "share('facebook')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-facebook-official",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "twitter",
                attrs: {
                  id: "share-twitter",
                  href: "javascript:void(0);",
                  onclick: "share('twitter')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-twitter",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "whatsapp",
                attrs: {
                  id: "share-whatsapp",
                  href: "javascript:void(0);",
                  onclick: "share('whatsapp')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-whatsapp",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "mail",
                attrs: {
                  id: "share-email",
                  href: "javascript:void(0);",
                  onclick: "share('email')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-envelope-o",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message" }, [
      _c("span", [
        _c("i", {
          staticClass: "fa fa-lock mr-1",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("Gerücht"),
        _c("br"),
        _vm._v("\n                      geschlossen")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "share menu", attrs: { id: "shareDiv" } }, [
      _c("li", { staticClass: "share top" }, [
        _c("i", { staticClass: "fa fa-share-alt" }),
        _vm._v(" "),
        _c("ul", { staticClass: "submenu" }, [
          _c("li", [
            _c(
              "a",
              {
                staticClass: "facebook",
                attrs: {
                  id: "share-facebook",
                  href: "javascript:void(0);",
                  onclick: "share('facebook')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-facebook-official",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "twitter",
                attrs: {
                  id: "share-twitter",
                  href: "javascript:void(0);",
                  onclick: "share('twitter')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-twitter",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "whatsapp",
                attrs: {
                  id: "share-whatsapp",
                  href: "javascript:void(0);",
                  onclick: "share('whatsapp')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-whatsapp",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "mail",
                attrs: {
                  id: "share-email",
                  href: "javascript:void(0);",
                  onclick: "share('email')"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-envelope-o",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }